exports.getLabelFromEnum = (value, typeEnum) => {
  let label = '';
  typeEnum.find((k) => {
    if (k.value === value) {
      label = k.label;
    }
  });
  return label;
};
